/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Dictionary } from '@ngrx/entity';
import { Observable } from 'rxjs';
import { UserGameProfileInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class UserGameProfileApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'UserGameProfiles');
  }

  getUserGameProfiles(methodCode: string, keys: string[]): Observable<Dictionary<UserGameProfileInterface>> {
    const params = new HttpParams({
      fromObject: {
        methodCode,
        keys: JSON.stringify(keys),
      },
    });
    return this.get('get', params);
  }

  saveUserGameProfile(userProfile: UserGameProfileInterface): Observable<UserGameProfileInterface> {
    return this.post('save', undefined, userProfile);
  }
}
